import { z } from "zod";

export const carrierDocumentSchema = z.object({
  document: z.string().max(50),
  active: z.boolean(),
  autoprint: z.boolean(),
  copies: z.number().min(1).default(1),
})

export type CarrierDocumentType = z.infer<typeof carrierDocumentSchema>;